import { Component} from '@angular/core';
import { Location } from '@angular/common';
import { Subject, Subscription } from 'rxjs';
import PerfectScrollbar from 'perfect-scrollbar';
import { Title } from '@angular/platform-browser';

import { ApiService } from './services/api.service';
import { GlobalDataBusService } from './shared/global-data-bus.service';
import { delay, takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

declare const $: any;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent {
  public isThemeLoaded: boolean = false;
  private _destroy$: Subject<boolean> = new Subject()
  public loading : boolean = false
  constructor(
    private Title: Title, public translate: TranslateService,private ApiService: ApiService,private _location: Location
  ) {
    console.log(GlobalDataBusService.facilityIdBefore)
    if(!this._location.path().toLowerCase().includes('/admin/')) {
      this.GetInitialValues()
      
    }
    else{
      GlobalDataBusService.facilityIdBefore = localStorage.getItem("facilityIdBefore")
      if(GlobalDataBusService.facilityIdBefore){
        GlobalDataBusService.Facility_ID = this.ApiService.Decrypt(GlobalDataBusService.facilityIdBefore);
        this._initAdminSettings(GlobalDataBusService.Facility_ID)
      }
    }
    
    translate.setDefaultLang('en');
    this.Title.setTitle(GlobalDataBusService.appName);
  }

  ngOnInit() {
    GlobalDataBusService.loadingSub.pipe(takeUntil(this._destroy$), delay(0)).subscribe(val => {
      this.loading = val
    })
  }

  private _initAdminSettings(facilityID : number){
    var param = { Usr_Id: "", 
      Usr_Pwd: "", Faci_Id: facilityID
    };
    this.ApiService.CommonService(`UserInfo/facilitySettings`, param).subscribe((Resp) => {
      if (Resp.Success) {
        var _facSettings = Resp.Payload
        if(!!_facSettings){
          try {
            var  _appsettings = _facSettings.Facility_Settiings
            if(!!_appsettings){
              var _setData = JSON.parse(_appsettings)
              Object.keys(_setData).forEach(_set => {
                GlobalDataBusService.appSettings[_set] = _setData[_set]
              })
            }
            if(!!_facSettings.appName) GlobalDataBusService.appName = _facSettings.appName
            if(!!_facSettings.appLogo) GlobalDataBusService.appLogo = _facSettings.appLogo
            if(!!_facSettings.appLogoProfile) GlobalDataBusService.appLogoProfile = _facSettings.appLogoProfile
          } catch (error) { }
        }
        

        // var _appLogo = Response.Payload[0].appLogo
        // if(!!_appLogo){
        //   GlobalDataBusService.appLogo
        // }
      }
    });
  }

  ngOnDestroy(): void {
    this._destroy$.next(true);
    this._destroy$.complete()
  }

  GetInitialValues() {
    debugger;
    this.loading = true;
    var _userInfo = JSON.parse(localStorage.getItem("UserInfo"))
    if(!_userInfo || !_userInfo.Pro_code) return
    debugger;
    var payload = { pro_code: _userInfo.Pro_code}
    this.ApiService.CommonService(`UserInfo/locations`, payload).subscribe((Resp) => {
      this.loading = false;
      let Response = Resp;
      if (Response.Success) {
        localStorage.setItem("HospitalList", JSON.stringify(Response.Payload));        
        try {
          var  _appsettings = Response.Payload[0].appSettings
          if(!!_appsettings){
            var _setData = JSON.parse(_appsettings)
            Object.keys(_setData).forEach(_set => {
              GlobalDataBusService.appSettings[_set] = _setData[_set]
            })
          }
          
        } catch (error) { }

        if(!!Response.Payload[0].appLogo) GlobalDataBusService.appLogo = Response.Payload[0].appLogo
        if(!!Response.Payload[0].appLogoProfile) GlobalDataBusService.appLogoProfile = Response.Payload[0].appLogoProfile
        if(!!Response.Payload[0].appName) GlobalDataBusService.appName = Response.Payload[0].appName
      }
    });
  }
}
